const TemplateQueryFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        sortable: false,
        defaultFilter: false,
        width: 70
    },
    {
        name: '模板名称',
        code: 'name',
        column: true,
        defaultFilter: true,
        listFilter: true,
        width: 300
    },
    {
        name: '发文机关',
        code: 'draftOrgTitle',
        column: true,
        sortable: false,
        align: 'left'
    },
    {
        name: '创建日期',
        align: 'left',
        code: 'creationDate',
        defaultFilter: true,
        sortable: false,
        listFilter: true,
        column: true,
        width: 300

    }
];
export default TemplateQueryFields;
